import { connect } from 'react-redux';
// import Report from '../../components/digital_rating/Report';
import PersonalDashbord from '../../components/dashboard/personalDashbord/PersonalDashbord';

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonalDashbord);
